export const sign = (n?: number | undefined) => (!n ? 0 : n < 0 ? -1 : 1);
